    import React, { useState } from 'react';
    import userManager from '../auth/userManager';
    import CircularProgress from '@mui/material/CircularProgress';


    /**
     * A form component where the user can input a serial number,
     * which is then sent to the backend for validation or lookup.
     * The result is displayed in the UI.
     */
    function SerialCheckForm() {
        const [serialNumber, setSerialNumber] = useState('');
        const [result, setResult] = useState(null);
        const [error, setError] = useState('');
        const [loading, setLoading] = useState(false);

        /**
         * Sends the entered serial number to the backend for checking.
         */
        const handleCheckSerial = async () => {
            setError('');
            setResult(null);
            setLoading(true); // 👈 Ladeanimation starten

            try {
                // 1) Retrieve the current user (token)
                const user = await userManager.getUser();
                if (!user) {
                    setError('No user or token found. Please log in again.');
                    return;
                }

                // 2) Get the Access Token
                const token = user.access_token;

                // 3) Make a POST request to the backend //add productive route!!!
                const response = await fetch('https://sla-checker-backend.copatools.com/api/check-serial', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ serialNumber })
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    let errorMsg = `Error: ${response.status}`;

                    if (response.status === 401 || errorData?.error === 'Invalid or expired token') {
                        // 1) Meldung
                        alert('Your token was invalid. Please log in again.');

                        // 2) User entfernen, Session beenden
                        await userManager.signoutRedirect();

                        // 3) Weiterleitung zur Loginseite
                        window.location.href = 'https://sla-checker.copatools.com';
                        return;
                    }
                    
                    if (errorData.status === 404) {
                        errorMsg = 'Not Found. Please check the entered Serial-Number.';
                    } else if (errorData.error) {
                        errorMsg = errorData.error;
                    }

                    throw new Error(errorMsg);
                }

                const data = await response.json();
                setResult(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        return (
            <div style={{ marginTop: '20px' }}>
                {/* Input area */}
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    <label style={{ marginRight: '10px', fontWeight: 'bold' }}>
                        Serial-Number:
                    </label>
                    <input
                        type="text"
                        value={serialNumber}
                        onChange={(e) => setSerialNumber(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleCheckSerial();
                            }
                        }}
                        style={{
                            padding: '8px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            marginRight: '10px',
                            width: '250px'
                        }}
                    />
                    <button
                        onClick={handleCheckSerial}
                        disabled={loading}
                        style={{
                            padding: '8px 16px',
                            border: 'none',
                            backgroundColor: loading ? '#6c757d' : '#007bff',
                            color: '#fff',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            borderRadius: '4px'
                        }}
                    >
                        {loading ? 'Checking...' : 'Check'}
                    </button>
                </div>

                {/* Loading indicator */}
                {loading && (
                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                        <CircularProgress />
                    </div>
                )}


                {/* Error display */}
                {error && (
                    <p style={{ color: 'red', marginTop: '10px' }}>
                        {error}
                    </p>
                )}

                {/* Success (result) display */}
                {result && (
                    <div
                        style={{
                            marginTop: '1rem',
                            padding: '16px',
                            borderRadius: '8px',
                            border: '1px solid #ddd',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            backgroundColor: '#fff',
                            maxWidth: '500px'
                        }}
                    >
                        <h2 style={{ marginBottom: '12px', borderBottom: '2px solid black', paddingBottom: '8px' }}>
                            License Information
                        </h2>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <tbody>
                            <tr>
                                <td style={{ fontWeight: 'bold', padding: '8px', borderBottom: '1px solid #ddd' }}>
                                    Serial Number:
                                </td>
                                <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                                    {result.serialNumber}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 'bold', padding: '8px', borderBottom: '1px solid #ddd' }}>
                                    SLA Type:
                                </td>
                                <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                                    {result.slaType}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 'bold', padding: '8px', borderBottom: '1px solid #ddd' }}>
                                    Support Period Until:
                                </td>
                                <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                                    {result.wartungszeitraumBis}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 'bold', padding: '8px' }}>
                                    Evaluation:
                                </td>
                                <td style={{ padding: '8px' }}>
                                    {result.evaluation ? 'Yes' : 'No'}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }

    export default SerialCheckForm;
